import { render, staticRenderFns } from "./NewConstructor.vue?vue&type=template&id=023d4822&scoped=true&"
import script from "./NewConstructor.vue?vue&type=script&lang=js&"
export * from "./NewConstructor.vue?vue&type=script&lang=js&"
import style0 from "./NewConstructor.vue?vue&type=style&index=0&id=023d4822&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023d4822",
  null
  
)

export default component.exports